module.exports = __webpack_public_path__ + "static/splyt-icon-a058ac49b360760dd3879ae96a9b6a00.png";